<div class="wnl-header">
  <p>
    WNL: Alert and oriented to person, place time and situation. Strong movement of all extremities.
    Normal speech. No tremors noted.
  </p>

  <mat-checkbox [checked]="wnlManager.allWNL" [indeterminate]="wnlManager.someWNL()"
    (change)="wnlManager.setAllWNL($event.checked)">
    All Within Normal Limits
  </mat-checkbox>
</div>

<div [formGroup]="formGroup()" class="form-container">
  <assessment-row title="Extremity Movement">
    <emr-input type="text" [control]="formGroup().controls.extremityMovement" />
  </assessment-row>

  <assessment-row title="Hand Grips">
    <emr-input type="select" [hasWNL]="true" [control]="formGroup().controls.handGrips"
      [options]="extremityStrengthOptions" [default]="handGripsDefault"
      [(wnl)]="wnlManager.controlColl['handGrips'].wnl" (wnlChange)="wnlManager.updateAllWNL()" />
  </assessment-row>

  <assessment-row title="LE Push/Pull">
    <emr-input type="select" [hasWNL]="true" [control]="formGroup().controls.lePushPull"
      [options]="extremityStrengthOptions" [default]="lePushPullDefault"
      [(wnl)]="wnlManager.controlColl['lePushPull'].wnl" (wnlChange)="wnlManager.updateAllWNL()" />
  </assessment-row>

  <assessment-row title="Glascow Coma Scale Score">
    <emr-input type="text" [control]="formGroup().controls.gcss" />
  </assessment-row>

  <h2>Sensation</h2>
  <div class="sensation">
    <emr-input type="select" [hasWNL]="true" label="RUE" [control]="formGroup().controls.sensationRue"
      [options]="sensationOptions" [default]="sensationDefault" [(wnl)]="wnlManager.controlColl['rue'].wnl"
      (wnlChange)="wnlManager.updateAllWNL()" [bottomSpace]="true" />
    <emr-input type="select" [hasWNL]="true" label="LUE" [control]="formGroup().controls.sensationLue"
      [options]="sensationOptions" [default]="sensationDefault" [(wnl)]="wnlManager.controlColl['lue'].wnl"
      (wnlChange)="wnlManager.updateAllWNL()" [bottomSpace]="true" />
    <emr-input type="select" [hasWNL]="true" label="RLE" [control]="formGroup().controls.sensationRle"
      [options]="sensationOptions" [default]="sensationDefault" [(wnl)]="wnlManager.controlColl['rle'].wnl"
      (wnlChange)="wnlManager.updateAllWNL()" [bottomSpace]="true" />
    <emr-input type="select" [hasWNL]="true" label="LLE" [control]="formGroup().controls.sensationLle"
      [options]="sensationOptions" [default]="sensationDefault" [(wnl)]="wnlManager.controlColl['lle'].wnl"
      (wnlChange)="wnlManager.updateAllWNL()" [bottomSpace]="true" />
  </div>

  <assessment-row title="Tremors">
    <emr-checkbox-group [control]="formGroup().controls.tremors" [options]="tremorsOptions" />
  </assessment-row>

  @if (patient().isObstetric()) {
  <assessment-row title="Epidural">
    <emr-checkbox [control]="formGroup().controls.isEpidural" label="Yes"></emr-checkbox>
  </assessment-row>

  @if (formGroup().controls.isEpidural.value) {
  <assessment-row title="Level of Sensory Block">
    <emr-input type="text" [control]="formGroup().controls.sensoryBlockLevel"></emr-input>
  </assessment-row>
  }

  <assessment-row title="Abnormal Reflexes Noted">
    <emr-input type="text" [control]="formGroup().controls.abnormalReflexesNoted"></emr-input>
  </assessment-row>
  }
</div>